export default "__VITE_ASSET__Cf1M5OLgVbiPnc_xTVv5_Q__"